<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout row
            wrap>
    <v-flex xs12>
      <v-breadcrumbs>
        <v-breadcrumbs-item>
          <v-icon left>home</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item>Courier</v-breadcrumbs-item>
        <v-breadcrumbs-item>{{$app.capitalizeFirstLetter($route.params.filter)}}</v-breadcrumbs-item>
      </v-breadcrumbs>
      <connection-manager ref="connectionManager"
                          v-model="loading"></connection-manager>
      <v-card class="pt-3">
        <v-data-iterator
          content-tag="v-expansion-panel"
          content-class="elevation-0"
          :no-data-text="loading ? '' : 'No data available'"
          :items="items"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination">
          <v-expansion-panel-content slot="item"
                                     slot-scope="props"
                                     lazy
                                     :value="items.length === 1">
            <!--Header-->
            <template slot="header" style="min-height: 250px">
              <div>
                <b style="color: #00bfa5">ID: {{ props.item.id }}</b>
                <!--{{ props.item.originFormattedAddress }}-->
                <b>From: {{ props.item.originName }}</b>-
                <timeago v-if="props.item.createdAt" class="accent--text"
                         :datetime="props.item.createdAt"></timeago>
                <v-chip color="accent"
                        label
                        small
                        class="mb-2"
                        text-color="white">
                  <b v-if="props.item.status === 'DELIVERED'">{{$app.formatMoney(props.item.actualDeliveryCost)}} incl. 16% VAT</b>
                  <b v-else>{{$app.formatMoney(props.item.estimatedCost)}} incl. 16% VAT</b>
                </v-chip>
                <v-chip v-for="(stat,i) in props.item.stats"
                        :key="i"
                        small
                        color="primary"
                        text-color="white">
                  <v-avatar :size="24">
                    <img style="max-height: 24px; max-width: 24px"
                         :src="$app.imageUrl(stat.courierOption.icon)"
                         :alt="stat.courierOption.name">
                  </v-avatar>
                  <b>{{stat.count}} {{stat.count > 1 ? stat.courierOption.pluralName :
                    stat.courierOption.name}}</b>
                </v-chip>
                <v-chip v-if="props.item.status === 'REJECTED'"
                        label
                        outline
                        color="red"
                        small>
                  <v-icon left>info</v-icon>
                  Rejected by {{props.item.rejectedBy.accountType}} - {{props.item.rejectedBy.name}}
                </v-chip>
                <v-chip v-if="props.item.status === 'CANCELLED'"
                        label
                        outline
                        color="red"
                        small>
                  <v-icon left>info</v-icon>
                  Cancelled by {{props.item.cancelledBy.accountType}} - {{props.item.cancelledBy.name}}
                </v-chip>
                <v-chip label
                        outline
                        color="info"
                        v-if="props.item.status === 'AT_DEPARTMENT_HEAD' && !isDepartmentHead()"
                        small>
                  <v-icon left>info</v-icon>
                  Pending Department Head approval
                </v-chip>
                <v-chip label
                        outline
                        color="info"
                        v-if="props.item.status === 'AT_PURCHASING_HEAD' && !isPurchasingHead()"
                        small>
                  <v-icon left>info</v-icon>
                  Pending Purchasing Head approval
                </v-chip>

                <v-btn flat
                       color="red"
                       small
                       outline
                       v-if="showApprovalActions(props.item)"
                       @click.native="reject(props.item)">
                  <v-icon left
                          small>close
                  </v-icon>
                  Reject
                </v-btn>
                <v-btn flat
                       color="success"
                       small
                       outline
                       v-if="showApprovalActions(props.item)"
                       @click.native="confirm(props.item)">
                  <v-icon left
                          small>check_circle
                  </v-icon>
                  Approve
                </v-btn>
                <v-btn flat
                       color="red"
                       small
                       outline
                       v-if="showCancelActions(props.item)"
                       @click.native="cancelDelivery(props.item)">
                  <v-icon left
                          small>close
                  </v-icon>
                  Cancel
                </v-btn>
                <!--<v-btn icon
                       class="mx-0"
                       @click="viewItem(props.item)">
                  <v-icon color="primary">visibility</v-icon>
                </v-btn>-->
              </div>
            </template>
            <!--Content-->
            <v-card>
              <v-card-text>
                <template v-for="(item,index) in props.item.items">
                  <v-layout row wrap
                            :key="index"
                  >
                    <v-flex align-self-center xs1>
                      <v-img
                        :src="$app.imageUrl(item.courierOption.icon)"
                        height="40px"
                        contain
                        class="align-self-center"
                      ></v-img>
                    </v-flex>
                    <v-flex xs8>
                      <div>
                        <v-list-tile-title class="body-2">
                          <b>{{item.quantity}} {{item.quantity > 1 ? item.courierOption.pluralName :
                            item.courierOption.name}}
                          </b>
                          <span v-if="item.status">- {{item.status}}</span><br/>
                          <span v-if="item.status === 'AT_DESTINATION'">
                            <v-chip color="accent"
                                    label
                                    small
                                    class="mb-2"
                                    text-color="white">
                                <b>{{$app.formatMoney(item.deliveryCost)}} incl. 16% VAT</b>
                            </v-chip>
                          </span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="caption">
                          <b>To: </b>{{item.destinationName}}<br/>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="caption">
                          <b>Address: </b>{{item.destinationFormattedAddress}}<br/>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="caption">
                          <b>Note: </b>{{item.note}}<br/>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title class="caption accent--text">Stops:</v-list-tile-sub-title>
                        <v-timeline
                          align-top
                          dense
                        >
                          <template v-for="(stop,index) in item.stops">
                            <v-timeline-item
                              color="pink"
                              small
                              :key="index"
                            >
                              <v-layout pt-1>
                                <v-flex xs6>
                                  <strong>{{stop.stopName}}</strong>
                                </v-flex>
                              </v-layout>
                            </v-timeline-item>
                          </template>
                        </v-timeline>
                      </div>
                    </v-flex>
                    <v-flex xs3>
                      <v-btn slot="activator"
                             @click="printingItem = item"
                             flat
                             v-if="item.status === 'PENDING_PICKUP'"
                             outline
                             color="primary">
                        Print QR
                      </v-btn>
                      <v-btn slot="activator"
                             @click="trackingItem = item"
                             flat
                             v-if="item.status ==='EN_ROUTE_TO_DESTINATION'"
                             outline
                             color="primary">
                        Track
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-divider inset
                             class="mt-2"
                             v-if="index !== props.item.items.length-1"
                             :key="index + props.item.items.length"/>
                </template>
              </v-card-text>
              <v-card-text>
              </v-card-text>
            </v-card>

          </v-expansion-panel-content>
        </v-data-iterator>
      </v-card>
    </v-flex>

    <add-delivery-dialog v-bind:show="addingDelivery"
                         @onClose="onCloseAddingDelivery">
    </add-delivery-dialog>

    <delivery-item-q-r-dialog :item="printingItem"
                              @onClose="printingItem = null"/>

    <v-fab-transition v-if="isDepartmentUser()">
      <v-btn class="ma-5"
             color="accent"
             fab
             dark
             fixed
             bottom
             @click.native="addingDelivery = true"
             right>
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>

  </v-layout>
</template>

<script>
  import Base from './Base.vue'
  import EventBus from '../event-bus'
  import moment from 'moment'
  import DeliveryItemQRDialog from './DeliveryItemQRDialog'
  import ConnectionManager from './ConnectionManager'
  import AddDeliveryDialog from './AddDeliveryDialog'

  export default {
    extends: Base,
    components: {
      AddDeliveryDialog,
      ConnectionManager,
      DeliveryItemQRDialog
    },
    name: 'courier',
    data () {
      return {
        addingDelivery: false,
        items: [],
        loading: false,
        trackingItem: null,
        printingItem: null,
        month: null,
        minMonth: null,
        viewDialogHere: false,
        maxMonth: null,
        rowsPerPageItems: [2, 4, 8],
        pagination: {
          rowsPerPage: 4
        },
        filter: null
      }
    },
    watch: {
      '$route' (to, from) {
        // react to route changes...
        if (to.params.filter !== this.filter) {
          this.filter = to.params.filter
        }
      },
      month (month) {
        if (month && this.filter && !this.connecting) {
          this.refresh()
        }
      },
      filter (val) {
        if (this.month && val && !this.connecting) {
          this.refresh()
        }
      }
    },
    methods: {
      showApprovalActions (item) {
        return this.filter === 'pendingApproval' && (
          (this.isPurchasingHead() && item.status === 'AT_PURCHASING_HEAD') ||
          (this.isDepartmentHead() && item.status === 'AT_DEPARTMENT_HEAD')
        )
      },
      showCancelActions (item) {
        return (this.filter === 'pendingPickup' || this.filter === 'inProgress') && (
          (this.isPurchasingHead() && item.status === 'PENDING_DELIVERY') ||
          (this.isPurchasingHead() && item.status === 'BEING_DELIVERED') ||
          (this.isDepartmentHead() && item.status === 'PENDING_DELIVERY') ||
          (this.isDepartmentHead() && item.status === 'BEING_DELIVERED')
        )
      },
      confirm (delivery) {
        this.items = []
        let that = this
        this.$refs.connectionManager.patch('deliveries/' + delivery.id, {
          onSuccess (response) {
            // that.items = []
            // that.items = that.items.concat(response.data.data)
            that.refresh()
            EventBus.$emit(that.$actions.approved)
          }
        }, {
          action: 'approve'
        })
      },
      reject (delivery) {
        this.items = []
        let that = this
        this.$refs.connectionManager.patch('deliveries/' + delivery.id, {
          onSuccess (response) {
            // that.items = []
            // that.items = that.items.concat(response.data.data)
            that.refresh()
            EventBus.$emit(that.$actions.rejected)
          }
        }, {
          action: 'reject'
        })
      },
      cancelDelivery (delivery) {
        this.items = []
        let that = this
        this.$refs.connectionManager.patch('deliveries/' + delivery.id, {
          onSuccess (response) {
            // that.items = []
            // that.items = that.items.concat(response.data.data)
            that.refresh()
            EventBus.$emit(that.$actions.rejected)
          }
        }, {
          action: 'cancel'
        })
      },
      onCloseAddingDelivery (refresh) {
        this.addingDelivery = false
        if (refresh) {
          this.refresh()
        }
      },
      refresh () {
        let that = this
        that.items = []
        this.$refs.connectionManager.get('/deliveries', {
          onSuccess (response) {
            that.items = []
            that.items = that.items.concat(response.data.data)
          }
        }, {
          filter: this.filter,
          month: this.month
        })
      }
    },
    created () {
      this.filter = this.$route.params.filter
    },
    mounted () {
      let dateClientJoined = moment(this.$auth.user().client.createdAt)
      this.minMonth = dateClientJoined.year() + '-' + (dateClientJoined.month())
      let today = moment()
      this.maxMonth = today.year() + '-' + (today.month() + 2)
      this.month = today.year() + '-' + today.month()
      this.filter = this.$route.params.filter
      let that = this
      EventBus.$on('refreshDeliveryHistoryList', function () {
        that.filter = this.$route.params.filter
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Courier.vue